import type { CustomerActivity } from '@brickup/shared/dto'
import { STAFF_DASHBOARD } from '@brickup/shared/locales/de/staff-dashboard'
import { CustomerActivityFeed } from './CustomerActivityFeed'
import { moreFooter } from './dashboard-links'
import { DashboardPanel, WindowBadge } from './DashboardLayout'

/**
 * What happened on the reader's projects inside the window.
 *
 * The same feed under the same heading on both dashboards that run projects —
 * the advisor's and the project manager's — with only the sentence under the
 * title differing, because what the reader is looking for differs.
 */
export function ActivityPanel({
  subtitle,
  activity,
  activityCount,
}: {
  subtitle: string
  activity: CustomerActivity[]
  activityCount: number
}) {
  return (
    <DashboardPanel
      title={STAFF_DASHBOARD.activity}
      subtitle={subtitle}
      badge={<WindowBadge />}
      footer={moreFooter(activityCount, activity.length)}
    >
      <CustomerActivityFeed activity={activity} />
    </DashboardPanel>
  )
}
